import { AddIncludeExcludeActionButtons } from './addIncludeExcludeActionButtons';
import { IncludeExcludeCondition } from './includeExcludeCondition';

interface IncludeExcludeEditorProps<
  T extends { include: string[]; exclude: string[] },
> {
  wizardState: T;
  setWizardState: (state: T) => void;
}

export const IncludeExcludeEditor = <
  T extends { include: string[]; exclude: string[] },
>(
  props: IncludeExcludeEditorProps<T>
) => {
  return (
    <>
      <IncludeExcludeCondition
        include={props.wizardState.include}
        exclude={props.wizardState.exclude}
        onExcludeDelete={(resourceId) => {
          props.setWizardState({
            ...props.wizardState,
            exclude: props.wizardState.exclude.filter((r) => r !== resourceId),
          });
        }}
        onIncludeDelete={(resourceId) => {
          props.setWizardState({
            ...props.wizardState,
            include: props.wizardState.include.filter((r) => r !== resourceId),
          });
        }}
      />
      <AddIncludeExcludeActionButtons
        onIncludeAdded={(resourceId) =>
          props.setWizardState({
            ...props.wizardState,
            include: [...props.wizardState.include, resourceId],
          })
        }
        onExcludeAdded={(resourceId) =>
          props.setWizardState({
            ...props.wizardState,
            exclude: [...props.wizardState.exclude, resourceId],
          })
        }
      />
    </>
  );
};
